import { editoSearchSelectors } from './editorSearchSelectors';
import { editorSearchReducer } from './editorSearchReducer';
import { editorSearchActions } from './editorSearchActions';

export const editorSearch = {
  actions: editorSearchActions,
  reducer: editorSearchReducer,
  selectors: editoSearchSelectors,
};
